<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {mapActions, mapGetters} from "vuex";

/**
 * Invoice-detail component
 */
export default {
    page: {
        title: "Invoice Detail",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Invoice Detail",
            order: this.$route.params.id,
        };
    },
    computed: {
        ...mapGetters("doctor", ["FetchedRadioReport"]),
    },
    methods: {
        ...mapActions({
            FetchRadioReport: "doctor/FetchRadioReport",
        }),
    },
    created() {
        this.FetchRadioReport(this.order);
    },
};
</script>
<style scoped>
tr, td {
    padding-top: 2px;
    padding-bottom: 2px;
}
.print {
    font-family: "Lucida Console", "Courier New", monospace;
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" />
        <div class="row">
            <div class="col-lg-12">
                <div class="d-print-none">
                    <div class="float-end">
                        <a href="javascript:window.print()"
                            class="btn btn-primary waves-effect waves-light me-1">
                            <i class="fa fa-print"></i> Print Invoice
                        </a>
                    </div>
                </div>
                <div class="d-print-none">
                    <button @click="$router.go(-1)" class="btn btn-success mb-2">
                        <i class="fas fa-arrow-circle-left"></i> Go Back
                    </button>
                </div>
                <div class="bg-white p-2 print">
                    <div class="invoice-title">
                        <div style="width: 100%; top: 0px; height: 130px">
                            <div style="width: 50%; float: left; top: 0px">
                                <img :src="FetchedRadioReport.logo" alt="Logo" height="115px"/>
                            </div>

                            <div style="width: 50%; float: right; top: 0px">
                                <p style="
                    text-transform: uppercase;
                    text-align: right;
                    font-size: 20px;
                    font-weight: bold;
                  ">
                                    {{ FetchedRadioReport.report.clinic.clini_name }}
                                </p>
                                <table align="right" width="100%" style="font-size: 12px">
                                    <tr align="right">
                                        <td>
                                            {{ FetchedRadioReport.report.clinic.clinic_address }}
                                        </td>
                                    </tr>
                                    <tr align="right">
                                        <td>
                                            <strong>Tel:</strong>
                                            {{ FetchedRadioReport.report.clinic.clinic_contact }}
                                        </td>
                                    </tr>
                                    <tr align="right">
                                        <td>
                                            <strong>Email:</strong>
                                            {{ FetchedRadioReport.report.clinic.clinic_email }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-12">
                            <div v-html="FetchedRadioReport.report.radio_report.radiology_report"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- end row -->
    </Layout>
</template>